<script setup lang="ts">
import { MMText } from '@mm-frontend/mm-web-ui-kit';

const environmentVariables = useRuntimeConfig().public;
</script>

<template>
  <div class="env-tab">
    <div class="env-tab__item" v-for="(val, key) in environmentVariables" :key="key">
      <MMText font="Caption S/Regular" color="disabled">{{ key }}</MMText>
      <MMText font="Caption S/Regular" color="secondary">{{ val }}</MMText>
    </div>
  </div>
</template>

<style scoped lang="stylus">
.env-tab
  display flex
  flex-direction column
  gap 4px
  padding 0 4px
  max-width 100%
  overflow-x auto
  min-height fit-content

  @media (max-width $pre-laptop)
    gap 8px

  &__item
    display flex
    column-gap 6px

    @media (max-width $pre-laptop)
      flex-direction column
</style>
